import PublicContentBase from '../../ContentBase'
import './Styles.scss'

const PublicContentCognitoDev = (): JSX.Element => {
    return <PublicContentBase />
}

export default PublicContentCognitoDev
